import Trending1 from "../images/trending1.png";
import Trending2 from "../images/trending2.jpg";

var Trending = [
    {
        subTitle: "Indian national news. Live",
        title: "Supreme Court transfers Gyanvapi case to Varanasi district judge",
        image: Trending1
    },
    {
        subTitle: "Cricket. Live",
        title: "IPL 2022: SunRisers Hyderabad at 43/1 at the end of Powerplay",
        image: Trending2
    },
    {
        subTitle: "Entertinement - Trending",
        title: "#LokeshKanagaraj",
        tweets: "2,563 Tweets"
    },
    {
        subTitle: "Entertinement - Trending",
        title: "#Thalapathy67",
        tweets: "66K Tweets"
    },
    {

        Show: "Show More"
    }
]

export default Trending;